module.exports = __webpack_public_path__ + "img/40.c34de826.png";